import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Theme, { useTheme } from '@amzn/meridian/theme';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { colors } from 'src/utils/colors';
import { Link } from 'src/common/styled';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
/**
 * Footer for the application
 * Converted from: https://code.amazon.com/packages/HandshakePainterComponents/blobs/mainline/--/src/kata/templates/common/Footer.kata
 *
 * TODO:
 *  - Detail page has extra `padding-bottom: 130px`. Why?
 */
export const Footer = () => {
    const [bundle, isBundleLoading] = useBundle('pages.app');
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.CONDITIONS_OF_USE, RetailRoutes.PRIVACY_NOTICE]);
    const theme = useTheme();
    const offRampToAmazon = useOffRampToAmazon();
    if (isBundleLoading)
        return null;
    const currentYear = new Date().getFullYear();
    // Prime and non-prime colors are the same for the footer
    const backgroundColor = theme.mode === 'dark' ? colors.headerFooterDarkMode : colors.headerFooterLightMode;
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        offRampToAmazon(url, ReportActionSource.Footer);
    };
    return (_jsx(Theme, { mode: "dark", children: _jsxs(Column, { alignmentHorizontal: "center", backgroundColor: backgroundColor, spacingInset: "400", spacing: "200", "data-testid": "footer", children: [_jsxs(Row, { alignmentHorizontal: "center", "data-testid": "footer-links", children: [_jsx(Link, { href: redirectUrls.CONDITIONS_OF_USE, onClick: openExternalLink, "data-testid": "conditions-of-use-link", children: _jsx(Text, { type: "b100", children: bundle.getMessage('conditionsOfUse') }) }), _jsx(Link, { href: redirectUrls.PRIVACY_NOTICE, onClick: openExternalLink, "data-testid": "privacy-notice-link", children: _jsx(Text, { type: "b100", children: bundle.getMessage('privacyNotice') }) })] }), _jsx(Row, { "data-testid": "copyright", children: _jsx(Text, { type: "b100", children: bundle.formatMessage('copyRight', { currentYear }) }) })] }) }));
};
